import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FilterStateService } from '../../services/filter-state/filter-state.service';

export const dataLoadedGuard: CanActivateFn = (route, state) => {
  const filterState = inject(FilterStateService);
  const router = inject(Router);

  const snapshot = filterState.getSnapshot();
  if (snapshot.selectedYear !== null && snapshot.selectedMonth !== null) {
    return true;
  } else {
    router.navigate(['home']);
    return false;
  }
};
